// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   Divider,
//   Chip,
// } from "@mui/material";

// import CloseIcon from "@mui/icons-material/Close";
// import { fmtRs } from "../../utils/payrollFormat";

// const PRIMARY = "#1B5C20";

// const formatDate = (value) => {
//   if (!value) return "-";

//   const date = new Date(value);

//   if (Number.isNaN(date.getTime())) {
//     return value;
//   }

//   return date.toLocaleDateString("en-GB", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// };

// /**
//  * Payroll Summary
//  *
//  * Uses a clean statement-style layout instead of individual cards.
//  * Net Salary receives a subtle green highlight.
//  */
// function PayrollSummary({ payroll }) {
//   const items = [
//     {
//       label: "Gross Earnings",
//       value: payroll.gross,
//     },
//     {
//       label: "Total Earnings to Gross",
//       value: payroll.totalEarnings,
//     },
//     {
//       label: "Total Deductions from Gross",
//       value: payroll.totalDeductions,
//     },
//     {
//       label: "Employee EPF",
//       value: payroll.epf,
//     },
//     {
//       label: "Employer EPF",
//       value: payroll.employerEpf,
//     },
//     {
//       label: "Employer ETF",
//       value: payroll.employerEtf,
//     },
//   ];

//   return (
//     <Box sx={{ mt: 2.5 }}>
//       <Typography
//         variant="subtitle1"
//         sx={{
//           fontWeight: 700,
//           mb: 1.5,
//           color: "#222",
//         }}
//       >
//         Payroll Summary
//       </Typography>

//       <Box
//         sx={{
//           border: "1px solid #EAEAEA",
//           borderRadius: 2,
//           overflow: "hidden",
//           backgroundColor: "#fff",
//         }}
//       >
//         {/* Summary Items */}
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: {
//               xs: "1fr",
//               sm: "repeat(2, 1fr)",
//             },
//           }}
//         >
//           {items.map((item, index) => (
//             <Box
//               key={item.label}
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 gap: 2,
//                 px: 2,
//                 py: 1.5,

//                 borderBottom: "1px solid #EAEAEA",

//                 borderRight: {
//                   xs: "none",
//                   sm:
//                     index % 2 === 0
//                       ? "1px solid #EAEAEA"
//                       : "none",
//                 },
//               }}
//             >
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: "#777",
//                 }}
//               >
//                 {item.label}
//               </Typography>

//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontWeight: 600,
//                   color: "#222",
//                   textAlign: "right",
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 {fmtRs(item.value)}
//               </Typography>
//             </Box>
//           ))}
//         </Box>

//         {/* Net Salary */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             gap: 2,
//             px: 2,
//             py: 1.75,
//             backgroundColor: "#F0F7F0",
//           }}
//         >
//           <Typography
//             variant="body2"
//             sx={{
//               fontWeight: 700,
//               color: PRIMARY,
//             }}
//           >
//             Net Salary
//           </Typography>

//           <Typography
//             variant="body1"
//             sx={{
//               fontWeight: 800,
//               color: PRIMARY,
//               textAlign: "right",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {fmtRs(payroll.net)}
//           </Typography>
//         </Box>
//       </Box>
//     </Box>
//   );
// }

// function DetailTable({ title, rows, type }) {
//   if (!rows || rows.length === 0) {
//     return null;
//   }

//   return (
//     <Box sx={{ mt: 3 }}>
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           gap: 1,
//           mb: 1.5,
//         }}
//       >
//         <Typography
//           variant="subtitle1"
//           sx={{
//             fontWeight: 700,
//             color: "#222",
//           }}
//         >
//           {title}
//         </Typography>

//         <Chip
//           label={`${rows.length} item${
//             rows.length !== 1 ? "s" : ""
//           }`}
//           size="small"
//           sx={{
//             backgroundColor:
//               type === "earning"
//                 ? "#E8F5E9"
//                 : "#FFF3E0",
//             color:
//               type === "earning"
//                 ? PRIMARY
//                 : "#B45309",
//             fontWeight: 600,
//           }}
//         />
//       </Box>

//       <Box
//         sx={{
//           border: "1px solid #EAEAEA",
//           borderRadius: 2,
//           overflow: "hidden",
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns:
//               "100px 1fr 1.5fr 120px",
//             gap: 1,
//             px: 2,
//             py: 1.25,
//             backgroundColor: "#1f1f1f",
//             color: "#34d399",
//           }}
//         >
//           <Typography
//             variant="caption"
//             sx={{ fontWeight: 700 }}
//           >
//             CODE
//           </Typography>

//           <Typography
//             variant="caption"
//             sx={{ fontWeight: 700 }}
//           >
//             COMPONENT
//           </Typography>

//           <Typography
//             variant="caption"
//             sx={{ fontWeight: 700 }}
//           >
//             DESCRIPTION
//           </Typography>

//           <Typography
//             variant="caption"
//             sx={{
//               fontWeight: 700,
//               textAlign: "right",
//             }}
//           >
//             AMOUNT
//           </Typography>
//         </Box>

//         {/* Rows */}
//         {rows.map((row, index) => (
//           <Box
//             key={`${row.componentId}-${index}`}
//             sx={{
//               display: "grid",
//               gridTemplateColumns:
//                 "100px 1fr 1.5fr 120px",
//               gap: 1,
//               px: 2,
//               py: 1.5,
//               borderTop: "1px solid #EAEAEA",
//               backgroundColor:
//                 index % 2 === 0
//                   ? "#fff"
//                   : "#FAFAFA",
//               alignItems: "center",
//             }}
//           >
//             <Typography
//               variant="body2"
//               sx={{
//                 fontWeight: 600,
//                 color: "#555",
//               }}
//             >
//               {row.componentCode || "-"}
//             </Typography>

//             <Typography variant="body2">
//               {row.componentName || "-"}
//             </Typography>

//             <Typography
//               variant="body2"
//               color="#666"
//             >
//               {row.description || "-"}
//             </Typography>

//             <Typography
//               variant="body2"
//               sx={{
//                 fontWeight: 600,
//                 textAlign: "right",
//               }}
//             >
//               {fmtRs(row.amount)}
//             </Typography>
//           </Box>
//         ))}
//       </Box>
//     </Box>
//   );
// }

// export default function PayrollBreakdownDialog({
//   open,
//   onClose,
//   payroll,
// }) {
//   if (!payroll) {
//     return null;
//   }

//   const details = payroll.details || [];

//   const earnings = details.filter(
//     (item) =>
//       String(item.componentType || "").toUpperCase() ===
//       "E"
//   );

//   const deductions = details.filter(
//     (item) =>
//       String(item.componentType || "").toUpperCase() ===
//       "D"
//   );

//   const other = details.filter((item) => {
//     const type = String(
//       item.componentType || ""
//     ).toUpperCase();

//     return type !== "E" && type !== "D";
//   });

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="lg"
//       fullWidth
//     >
//       {/* Dialog Header */}
//       <DialogTitle
//         sx={{
//           px: 3,
//           pt: 2.5,
//           pb: 2,
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             gap: 2,
//           }}
//         >
//           <Box>
//             <Typography
//               variant="h6"
//               sx={{
//                 fontWeight: 700,
//                 color: "#222",
//               }}
//             >
//               Payroll Breakdown
//             </Typography>

//             <Typography
//               variant="body2"
//               color="#666"
//               sx={{ mt: 0.5 }}
//             >
//               {payroll.name || "-"}{" "}
//               {payroll.empNo
//                 ? `(${payroll.empNo})`
//                 : ""}
//             </Typography>
//           </Box>

//           <Button
//             onClick={onClose}
//             sx={{
//               minWidth: 40,
//               width: 40,
//               height: 40,
//               borderRadius: 2,
//               color: "#666",
//             }}
//           >
//             <CloseIcon fontSize="small" />
//           </Button>
//         </Box>
//       </DialogTitle>

//       <DialogContent
//         dividers
//         sx={{
//           px: 3,
//           py: 2.5,
//           backgroundColor: "#FAFAFA",
//         }}
//       >
//         {/* Employee / Payroll Information */}
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: {
//               xs: "1fr",
//               sm: "repeat(2, 1fr)",
//               md: "repeat(4, 1fr)",
//             },
//             gap: 1.5,
//             mb: 2.5,
//           }}
//         >
//           <Box>
//             <Typography
//               variant="caption"
//               color="#888"
//             >
//               Employee
//             </Typography>

//             <Typography
//               variant="body2"
//               fontWeight={600}
//             >
//               {payroll.name || "-"}
//             </Typography>
//           </Box>

//           <Box>
//             <Typography
//               variant="caption"
//               color="#888"
//             >
//               Service No
//             </Typography>

//             <Typography
//               variant="body2"
//               fontWeight={600}
//             >
//               {payroll.empNo || "-"}
//             </Typography>
//           </Box>

//           <Box>
//             <Typography
//               variant="caption"
//               color="#888"
//             >
//               Payroll No
//             </Typography>

//             <Typography
//               variant="body2"
//               fontWeight={600}
//             >
//               {payroll.payrollNo || "-"}
//             </Typography>
//           </Box>

//           <Box>
//             <Typography
//               variant="caption"
//               color="#888"
//             >
//               Pay Date
//             </Typography>

//             <Typography
//               variant="body2"
//               fontWeight={600}
//             >
//               {formatDate(payroll.payDate)}
//             </Typography>
//           </Box>
//         </Box>

//         {/* Attendance Information */}
//         <Box
//           sx={{
//             border: "1px solid #EAEAEA",
//             borderRadius: 2,
//             backgroundColor: "#fff",
//             p: 2,
//           }}
//         >
//           <Typography
//             variant="subtitle2"
//             sx={{
//               fontWeight: 700,
//               mb: 1.5,
//             }}
//           >
//             Attendance & Payroll Days
//           </Typography>

//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: {
//                 xs: "repeat(2, 1fr)",
//                 sm: "repeat(4, 1fr)",
//               },
//               gap: 2,
//             }}
//           >
//             <Box>
//               <Typography
//                 variant="caption"
//                 color="#888"
//               >
//                 Working Days
//               </Typography>

//               <Typography fontWeight={600}>
//                 {payroll.workingDays}
//               </Typography>
//             </Box>

//             <Box>
//               <Typography
//                 variant="caption"
//                 color="#888"
//               >
//                 Present Days
//               </Typography>

//               <Typography fontWeight={600}>
//                 {payroll.presentDays}
//               </Typography>
//             </Box>

//             <Box>
//               <Typography
//                 variant="caption"
//                 color="#888"
//               >
//                 No Pay Days
//               </Typography>

//               <Typography fontWeight={600}>
//                 {payroll.noPayDays}
//               </Typography>
//             </Box>

//             <Box>
//               <Typography
//                 variant="caption"
//                 color="#888"
//               >
//                 OT Hours
//               </Typography>

//               <Typography fontWeight={600}>
//                 {payroll.otHours}
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         {/* Payroll Summary */}
//         <PayrollSummary payroll={payroll} />

//         <Divider sx={{ mt: 3 }} />

//         {/* Component Details */}
//         <DetailTable
//           title="Earnings"
//           rows={earnings}
//           type="earning"
//         />

//         <DetailTable
//           title="Deductions"
//           rows={deductions}
//           type="deduction"
//         />

//         {other.length > 0 && (
//           <DetailTable
//             title="Other Components"
//             rows={other}
//             type="earning"
//           />
//         )}

//         {/* Empty Details */}
//         {details.length === 0 && (
//           <Box
//             sx={{
//               textAlign: "center",
//               py: 5,
//             }}
//           >
//             <Typography
//               variant="body2"
//               color="#777"
//             >
//               No component breakdown is available
//               for this payroll.
//             </Typography>
//           </Box>
//         )}
//       </DialogContent>

//       {/* Footer */}
//       <DialogActions
//         sx={{
//           px: 3,
//           py: 1.5,
//         }}
//       >
//         <Button
//           onClick={onClose}
//           variant="contained"
//           sx={{
//             backgroundColor: PRIMARY,
//             textTransform: "none",
//             borderRadius: 2,
//             px: 3,
//             "&:hover": {
//               backgroundColor: "#145016",
//             },
//           }}
//         >
//           Close
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// --------------------------------------------------------------------------------------------

import React, { useState, useRef, useEffect } from "react";
import {
  X,
  HelpCircle,
  TrendingUp,
  TrendingDown,
  Wallet,
  Building2,
} from "lucide-react";
import { fmtRs } from "../../utils/payrollFormat";

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
};

/**
 * Self-positioning Calculation Popover that prevents clipping
 */
function CalcInfoButton({ title, formula, details, placement = "bottom" }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <span className="relative inline-flex items-center align-middle" ref={containerRef}>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        className={`ml-1 inline-flex items-center justify-center rounded p-0.5 transition-colors focus:outline-none ${
          open
            ? "text-primary-600 bg-primary-50 ring-1 ring-primary-300"
            : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"
        }`}
        title="View calculation breakdown"
      >
        <HelpCircle size={14} />
      </button>

      {open && (
        <div
          className={`absolute z-[999] w-72 rounded-lg border border-gray-200 bg-white p-3 text-left shadow-xl ring-1 ring-black/5 animate-in fade-in zoom-in-95 duration-100 ${
            placement === "top"
              ? "bottom-full mb-1.5 left-0"
              : "top-full mt-1.5 left-0"
          }`}
          style={{ maxWidth: "calc(100vw - 32px)" }}
        >
          <div className="flex items-center justify-between pb-1 mb-1 border-b border-gray-100">
            <span className="text-[10px] font-bold uppercase tracking-wider text-primary-700">
              Calculation Breakdown
            </span>
          </div>
          <p className="mt-1 text-xs font-semibold text-gray-900">{title}</p>
          <div className="mt-1.5 rounded border border-gray-200 bg-gray-50 px-2 py-1.5 font-mono text-[11px] text-gray-800 break-words leading-relaxed">
            {formula}
          </div>
          {details && (
            <p className="mt-1.5 text-[11px] leading-relaxed text-gray-500">
              {details}
            </p>
          )}
        </div>
      )}
    </span>
  );
}

export default function PayrollBreakdownDialog({ open, onClose, payroll }) {
  if (!open || !payroll) return null;

  const isNoPayItem = (item) => {
    const code = String(item.componentCode || item.COMPONENT_CODE || item.HPC_COMPONENT_CODE || "").toUpperCase();
    return code === "NOPAY" || code === "NO-PAY"
  }

  // Normalize casing
  const empName = payroll.name || payroll.EMPLOYEE_NAME || "-";
  const empNo = payroll.empNo || payroll.serviceNo || payroll.SERVICE_NO || "-";
  const payrollNo = payroll.payrollNo || payroll.PAYROLL_NO || "-";
  const payDate = payroll.payDate || payroll.PAY_DATE;

  const isWeekly = payroll.payFrequency === "W" || payroll.payFrequency === "Weekly";

  const presentDays = Number(payroll.presentDays ?? payroll.PRESENT_DAYS ?? 0);

  const workingDays = isWeekly ? presentDays : Number(payroll.workingDays ?? payroll.WORKING_DAYS ?? 0);

  const noPayDays = isWeekly ? 0 : Number(payroll.noPayDays ?? payroll.NO_PAY_DAYS ?? 0);
  const extraDays = isWeekly ? 0 : Math.max(0, presentDays - workingDays);

  const otHours = Number(payroll.otHours ?? payroll.OT_HOURS ?? 0);

  const totalGross = Number(payroll.gross ?? payroll.GROSS_EARNINGS ?? 0);
  const totalEarnings = Number(
    payroll.totalEarnings ?? payroll.TOTAL_EARNINGS ?? totalGross
  );
  const totalDeductions = Number(
    payroll.totalDeductions ?? payroll.TOTAL_DEDUCTIONS ?? 0
  );
  const employeeEpf = Number(payroll.epf ?? payroll.EMPLOYEE_EPF ?? 0);
  const employerEpf = Number(
    payroll.employerEpf ?? payroll.EMPLOYER_EPF ?? 0
  );
  const employerEtf = Number(
    payroll.employerEtf ?? payroll.EMPLOYER_ETF ?? 0
  );
  const netSalary = Number(
    payroll.net ?? payroll.NET_SALARY ?? totalEarnings - totalDeductions
  );

  const details = payroll.details || payroll.Details || [];

  const earnings = details.filter((item) => {
    const type = String(item.componentType || item.COMPONENT_TYPE || "").toUpperCase();
    return type === "E";
  })
  .sort((a, b) => {
    const aCode = String(a.componentCode || a.COMPONENT_CODE || "").toUpperCase();
    const bCode = String(b.componentCode || b.COMPONENT_CODE || "").toUpperCase();

    const aIsBasic = aCode === "BASIC" || aCode === "BASIC-SAL";
    const bIsBasic = bCode === "BASIC" || bCode === "BASIC-SAL";

    if (aIsBasic && !bIsBasic) return -1;
    if (!aIsBasic && bIsBasic) return 1;

    return 0;
  });

  const deductions = details.filter((item) => {
    const type = String(
      item.componentType || item.COMPONENT_TYPE || ""
    ).toUpperCase();
    return type === "D";
  });

  // Extract base salary and no-pay component if present
  const basicComponent = earnings.find((e) => {
    const code = String(
      e.componentCode || e.COMPONENT_CODE || ""
    ).toUpperCase();
    return code === "BASIC" || code === "BASIC-SAL";
  });

  // const noPayComponent = deductions.find((d) => {
  //   const code = String(
  //     d.componentCode || d.COMPONENT_CODE || ""
  //   ).toUpperCase();
  //   return code === "NOPAY" || code === "NO-PAY";
  // });

  const basicSalaryAmount = basicComponent
    ? Number(basicComponent.amount || basicComponent.AMOUNT || 0)
    : employeeEpf > 0
    ? employeeEpf / 0.08
    : totalEarnings;

  // const noPayAmount = noPayComponent
  //   ? Number(noPayComponent.amount || noPayComponent.AMOUNT || 0)
  //   : 0;

  // Contributory Salary for EPF/ETF (Basic - No Pay when deducted from base)
  // const salaryForEpfEtf = basicSalaryAmount - noPayAmount;

  const totalEarningsCalculated =
    earnings.reduce(
      (sum, item) => sum + Number(item.amount || item.AMOUNT || 0),
      0
    ) || totalEarnings;

  const totalDeductionsCalculated =
    deductions
      .filter((item) => !isNoPayItem(item))
      .reduce(
        (sum, item) => sum + Number(item.amount || item.AMOUNT || 0),
        0
      ) || totalDeductions;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-[2px] transition-opacity"
        onClick={onClose}
      />

      {/* Dialog Container */}
      <div className="relative z-10 flex max-h-[94vh] w-full max-w-5xl flex-col rounded-xl border border-gray-200 bg-white shadow-2xl">
        {/* Header */}
        <div className="flex shrink-0 items-center justify-between border-b border-gray-200 px-6 py-4">
          <div>
            <div className="flex items-center gap-2.5">
              <h2 className="text-base font-semibold text-gray-900">
                Payroll Breakdown
              </h2>
              <span className="rounded border border-gray-200 bg-gray-50 px-2 py-0.5 text-xs font-semibold text-gray-600">
                {payrollNo}
              </span>
            </div>
            <p className="mt-0.5 text-xs text-gray-500">
              {empName} • Service No:{" "}
              <strong className="text-gray-700">{empNo}</strong> • Pay Date:{" "}
              {formatDate(payDate)}
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        {/* Content Body */}
        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-4 bg-gray-50/50">
          {/* Attendance Overview Strip */}
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 rounded-lg border border-gray-200 bg-white p-3 text-center">
            <div>
              <p className="text-[11px] font-medium text-gray-500 uppercase tracking-wider">
                Working Days
              </p>
              <p className="mt-0.5 text-sm font-semibold text-gray-800">
                {workingDays.toFixed(1)}
              </p>
            </div>
            <div>
              <p className="text-[11px] font-medium text-gray-500 uppercase tracking-wider">
                Present Days
              </p>
              <p className="mt-0.5 text-sm font-semibold text-primary-700">
                {presentDays.toFixed(1)}
              </p>
            </div>
            <div>
              <div className="flex items-center justify-center">
                <span className="text-[11px] font-medium text-gray-500 uppercase tracking-wider">
                  No Pay Days
                </span>
                {noPayDays > 0 && (
                  <CalcInfoButton
                    title="No Pay Days"
                    formula={`${noPayDays.toFixed(1)} Unpaid Days Recorded`}
                    details="Unpaid absences deducted according to company leave guidelines."
                  />
                )}
              </div>
              <p
                className={`mt-0.5 text-sm font-semibold ${
                  noPayDays > 0 ? "text-amber-700" : "text-gray-800"
                }`}
              >
                {noPayDays.toFixed(1)}
              </p>
            </div>
            <div>
              <p className="text-[11px] font-medium text-gray-500 uppercase tracking-wider">
                Extra Days
              </p>
              <p className="mt-0.5 text-sm font-semibold text-gray-800">
                {extraDays.toFixed(1)}
              </p>
            </div>
            <div>
              <p className="text-[11px] font-medium text-gray-500 uppercase tracking-wider">
                OT Hours
              </p>
              <p className="mt-0.5 text-sm font-semibold text-gray-800">
                {otHours.toFixed(2)}
              </p>
            </div>
          </div>

          {/* Core Summary KPI Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
            {/* Total Earnings to Gross */}
            <div className="rounded-lg border border-gray-200 bg-white p-3.5">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <span className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                    Total Earnings to Gross
                  </span>
                  <CalcInfoButton
                    title="Total Earnings to Gross"
                    formula="Contributory Base + Allowances + Overtime"
                    details={`Basic Salary (${fmtRs(
                      basicSalaryAmount
                    )}) plus all earned allowances, incentives, and OT.`}
                  />
                </div>
                <TrendingUp size={15} className="text-gray-400" />
              </div>
              <p className="mt-2 text-base font-bold text-gray-900">
                {fmtRs(totalEarningsCalculated)}
              </p>
            </div>

            {/* Total Deductions */}
            <div className="rounded-lg border border-gray-200 bg-white p-3.5">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <span className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                    Total Deductions
                  </span>
                  <CalcInfoButton
                    title="Total Deductions"
                    formula="Pre-Gross Deductions + EPF (8%) + Taxes"
                    details="Salary advances, loan recoveries and EPF employee contribution. No-Pay is already applied to earnings."
                  />
                </div>
                <TrendingDown size={15} className="text-gray-400" />
              </div>
              <p className="mt-2 text-base font-bold text-gray-900">
                {fmtRs(totalDeductionsCalculated)}
              </p>
            </div>

            {/* Net Salary (Take-home) */}
            <div className="rounded-lg border border-primary-200 bg-primary-50/40 p-3.5">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <span className="text-[11px] font-bold text-primary-800 uppercase tracking-wider">
                    Net Salary
                  </span>
                  <CalcInfoButton
                    title="Net Salary (Take Home)"
                    formula="Total Earnings to Gross - Total Deductions"
                    details={`${fmtRs(
                      totalEarningsCalculated
                    )} - ${fmtRs(totalDeductionsCalculated)} = ${fmtRs(
                      netSalary
                    )}`}
                  />
                </div>
                <Wallet size={15} className="text-primary-700" />
              </div>
              <p className="mt-2 text-base font-bold text-primary-700">
                {fmtRs(netSalary)}
              </p>
            </div>

            {/* Employer Contributions */}
            <div className="rounded-lg border border-gray-200 bg-white p-3.5">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <span className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                    Employer Contributions
                  </span>
                  <CalcInfoButton
                    title="Employer Statutory Cost"
                    formula="EPF (12%) + ETF (3%) on Salary for EPF & ETF"
                    details={`Direct company contribution: EPF 12% (${fmtRs(
                      employerEpf
                    )}) and ETF 3% (${fmtRs(employerEtf)}).`}
                  />
                </div>
                <Building2 size={15} className="text-gray-400" />
              </div>
              <p className="mt-2 text-base font-bold text-gray-900">
                {fmtRs(employerEpf + employerEtf)}
              </p>
            </div>
          </div>

          {/* Side-by-Side Breakdown Tables */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
            {/* LEFT: EARNINGS */}
            <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
              <div className="flex items-center justify-between border-b border-gray-200 bg-gray-50/80 px-4 py-2.5 rounded-t-lg">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-bold text-gray-800">
                    Earnings to Gross
                  </span>
                  <span className="rounded bg-gray-200 px-1.5 py-0.5 text-[10px] font-semibold text-gray-700">
                    {earnings.length}
                  </span>
                </div>
                <span className="text-[11px] text-gray-400">Additions</span>
              </div>

              {/* Table Column Headers */}
              <div className="grid grid-cols-[80px_1fr_105px] border-b border-gray-200 bg-gray-50/40 px-4 py-1.5 text-[11px] font-semibold text-gray-500">
                <span>Code</span>
                <span>Component</span>
                <span className="text-right">Amount (Rs)</span>
              </div>

              {/* Rows */}
              <div className="divide-y divide-gray-100">
                {earnings.length === 0 ? (
                  <p className="py-6 text-center text-xs text-gray-400">
                    No earning components found.
                  </p>
                ) : (
                  earnings.map((row, idx) => {
                    const code = row.componentCode || row.COMPONENT_CODE || "-";
                    const name = row.componentName || row.COMPONENT_NAME || "-";
                    const amount = Number(row.amount || row.AMOUNT || 0);
                    const quantity = row.quantity || row.QUANTITY;

                    let calcFormula = null;
                    let calcDetails = null;

                    if (code === "ATTEND-ALLOW" && quantity) {
                      const unitRate = amount / Number(quantity);
                      calcFormula = `${Number(quantity).toFixed(0)} present days × Rs. ${unitRate.toFixed(2)}`;
                      calcDetails = "Configured daily allowance multiplied by present working days.";
                    } else if (code === "BASIC") {
                      calcFormula = "Basic after No-Pay reduction";
                      calcDetails = "Contracted basic less its No-Pay share for absent days. Basic Salary / 30 * No Pay Days";
                    }

                    return (
                      <div
                        key={`${code}-${idx}`}
                        className="grid grid-cols-[80px_1fr_105px] items-center px-4 py-2 text-xs hover:bg-gray-50/60 transition-colors"
                      >
                        <span className="font-mono text-gray-500">{code}</span>
                        <div className="flex items-center text-gray-800">
                          <span>{name}</span>
                          {calcFormula && (
                            <CalcInfoButton
                              title={name}
                              formula={calcFormula}
                              details={calcDetails}
                            />
                          )}
                        </div>
                        <span className="text-right font-medium text-gray-900 tabular-nums">
                          {fmtRs(amount)}
                        </span>
                      </div>
                    );
                  })
                )}
              </div>

              {/* Total Row */}
              <div className="flex items-center justify-between border-t border-gray-200 bg-gray-50/80 px-4 py-2.5 text-xs font-semibold text-gray-900 rounded-b-lg">
                <span>Total Earnings</span>
                <span className="tabular-nums">
                  {fmtRs(totalEarningsCalculated)}
                </span>
              </div>
            </div>

            {/* RIGHT: DEDUCTIONS */}
            <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
              <div className="flex items-center justify-between border-b border-gray-200 bg-gray-50/80 px-4 py-2.5 rounded-t-lg">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-bold text-gray-800">
                    Deductions & Contributions
                  </span>
                  <span className="rounded bg-gray-200 px-1.5 py-0.5 text-[10px] font-semibold text-gray-700">
                    {deductions.filter((d) => !isNoPayItem(d)).length}
                  </span>
                </div>
                <span className="text-[11px] text-gray-400">Subtractions</span>
              </div>

              {/* Table Column Headers */}
              <div className="grid grid-cols-[80px_1fr_105px] border-b border-gray-200 bg-gray-50/40 px-4 py-1.5 text-[11px] font-semibold text-gray-500">
                <span>Code</span>
                <span>Component</span>
                <span className="text-right">Amount (Rs)</span>
              </div>

              {/* Rows */}
              <div className="divide-y divide-gray-100">
                {deductions.length === 0 ? (
                  <p className="py-6 text-center text-xs text-gray-400">
                    No deduction components found.
                  </p>
                ) : (
                  deductions.map((row, idx) => {
                    const code = row.componentCode || row.COMPONENT_CODE || "-";
                    const isEpfEe =
                      code === "EPF-EE" ||
                      String(row.componentName || "").includes("EPF");
                    const isNoPay = isNoPayItem(row)
                    const name = isEpfEe
                      ? "EPF Employee Contribution (8%)"
                      : row.componentName || row.COMPONENT_NAME || "-";
                    const amount = Number(row.amount || row.AMOUNT || 0);
                    const quantity = row.quantity || row.QUANTITY;

                    let calcFormula = null;
                    let calcDetails = null;

                    if (isEpfEe) {
                      calcFormula = `8% × ${fmtRs(basicSalaryAmount)} (Salary for EPF & ETF)`;
                      calcDetails = "Statutory 8% EPF Employee Contribution calculated on the contributory salary base.";
                    } else if (isNoPay) {
                      const days = quantity ? Number(quantity).toFixed(0) : noPayDays.toFixed(0);
                      const dailyRate = Number(days) > 0 ? (amount / Number(days)).toFixed(2) : "0.00";
                      calcFormula = `${days} no-pay day(s) × Rs. ${dailyRate}`;
                      calcDetails = "Information only. Already deducted from Basic and other fixed allowances, so it is not part of Total Deductions. EPF/ ETF is calculated on the reduced Basic Salary.";
                    }

                    return (
                      <div
                        key={`${code}-${idx}`}
                        className={`grid grid-cols-[80px_1fr_105px] items-center px-4 py-2 text-xs hover:bg-gray-50/60 transition-colors ${
                          isNoPay ? "bg-gray-50/70 text-gray-400 italic" : "hover:bg-gray-50/60"
                        }`}
                      >
                        <span className="font-mono text-gray-500">{code}</span>
                        <div className="flex items-center text-gray-800">
                          <span>{name}</span>
                          {calcFormula && (
                            <CalcInfoButton
                              title={name}
                              formula={calcFormula}
                              details={calcDetails}
                            />
                          )}
                        </div>
                        <span className={`text-right tabular-nums ${isNoPay ? "text-gray-400" : "font-medium text-gray-900"}`}>
                          {isNoPay ? `(${fmtRs(amount)})` : fmtRs(amount)}
                        </span>
                      </div>
                    );
                  })
                )}
              </div>

              {/* Total Row */}
              <div className="flex items-center justify-between border-t border-gray-200 bg-gray-50/80 px-4 py-2.5 text-xs font-semibold text-gray-900 rounded-b-lg">
                <span>Total Deductions</span>
                <span className="tabular-nums">
                  {fmtRs(totalDeductionsCalculated)}
                </span>
              </div>
            </div>
          </div>

          {/* Employer Statutory Cost Details Strip */}
          <div className="rounded-lg border border-gray-200 bg-white p-3.5">
            <div className="flex items-center justify-between pb-2 mb-2 border-b border-gray-100">
              <div className="flex items-center">
                <span className="text-xs font-bold text-gray-800">
                  Employer Statutory Contributions (Direct Company Cost)
                </span>
                <CalcInfoButton
                  title="Employer EPF & ETF Breakdown"
                  formula="EPF (12%) + ETF (3%) on Salary for EPF & ETF"
                  details={`Directly remitted by company on a contributory base of ${fmtRs(
                    basicSalaryAmount
                  )}`}
                  placement="top"
                />
              </div>
              <span className="text-[11px] text-gray-500">
                Salary for EPF & ETF:{" "}
                <strong className="text-gray-700">
                  {fmtRs(basicSalaryAmount)}
                </strong>
              </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs">
              <div className="flex justify-between items-center rounded border border-gray-100 bg-gray-50/60 px-3 py-2">
                <span className="text-gray-600">Employer EPF (12%)</span>
                <span className="font-semibold text-gray-900 tabular-nums">
                  {fmtRs(employerEpf)}
                </span>
              </div>
              <div className="flex justify-between items-center rounded border border-gray-100 bg-gray-50/60 px-3 py-2">
                <span className="text-gray-600">Employer ETF (3%)</span>
                <span className="font-semibold text-gray-900 tabular-nums">
                  {fmtRs(employerEtf)}
                </span>
              </div>
              <div className="flex justify-between items-center rounded border border-primary-200 bg-primary-50/30 px-3 py-2">
                <span className="font-semibold text-primary-800">
                  Total Employer Cost
                </span>
                <span className="font-bold text-primary-700 tabular-nums">
                  {fmtRs(employerEpf + employerEtf)}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex shrink-0 items-center justify-end border-t border-gray-200 px-6 py-3 bg-white rounded-b-xl">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-9 items-center justify-center rounded-md bg-primary-600 px-5 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}